module.exports = __webpack_public_path__ + "static/media/LandingForms.12039c55.svg";